import React             from "react";

import {
  PhotoViewVariants,
  Image,
  photo_view_variants, } from "src/components/features/main/photo-view/ui";

type Props = {
  imgUrl: string | null;
  variant: PhotoViewVariants
};



export const PhotoView: React.FC<Props> = ({
  imgUrl,
  variant = 'photo_view_main',
}) => {
  const lookAndFeel = photo_view_variants.get(variant)!;

  return (
    <React.Fragment>
      {imgUrl && <Image lookAndFeel = { lookAndFeel } src = { imgUrl } alt = 'photo' />}
    </React.Fragment>
  );
};
